import FeatureGates from '@atlaskit/feature-gate-js-client';

export const isProfileMacrosExperimentEnabled = () => {
	return FeatureGates.getExperimentValue<boolean>(
		'confluence_profile_macros_updates',
		'isEnabled',
		false,
	);
};
